module.exports = __webpack_public_path__ + "static/media/about img5.1dd64763.webp";